<template>
  <q-list bordered class="q-pa-md q-pa-lg-lg bg-white more-rounded-borders" v-if="!should_hide">
    <q-expansion-item v-model="expanded" header-class="text-bold" header-style="font-size: 20px"
                      icon="o_account_circle" label="Your Info">
      <q-card>

        <q-card-section v-if="!is_service_location" class="q-my-sm q-py-none">

          <q-separator class="q-mb-md"></q-separator>

          <property-section>
            <property-item label="Service Address:" :value="service_location_address"></property-item>

            <div class="flex q-gutter-x-sm text-100">
              <div class="text-bold"> ESIID:</div>
              <div class="text-bold"> {{ service_location_id }}</div>
            </div>
          </property-section>
          <q-btn v-if="show_edit" label="change" flat color="primary" padding="0px" class="text-075" no-caps
                 @click="change_info('/order/service_location')"></q-btn>
        </q-card-section>

        <q-card-section v-if="!is_customer_info && has_customer_info" class="q-my-sm q-py-none">

          <q-separator class="q-mb-md"></q-separator>

          <property-section>
            <property-item v-if="first_name" label="First Name:" :value="first_name"></property-item>
            <property-item v-if="last_name" label="Last Name:" :value="last_name"></property-item>
            <property-item v-if="phone_number" label="Mobile Phone:" :value="formatted_phone"></property-item>
            <property-item v-if="email" label="Email:" :value="email"></property-item>
          </property-section>
          <q-btn v-if="show_edit" label="change" flat color="primary" padding="0px" class="text-075" no-caps
                 @click="change_info('/order/customer_information')"></q-btn>

        </q-card-section>


        <q-card-section v-if="!is_start_date && has_start_date" class="q-my-sm q-py-none">

          <q-separator class="q-mb-md"></q-separator>

          <property-section>
            <property-item label="Service Type:" :value="start_date_string"></property-item>
          </property-section>
          <q-btn v-if="show_edit" label="change" flat color="primary" padding="0px" class="text-075" no-caps
                 @click="change_info('/order/start_date')"></q-btn>

        </q-card-section>


      </q-card>

    </q-expansion-item>
  </q-list>
</template>

<script>
import { computed, ref } from "vue";
import ServiceLocation from "src/composables/ServiceLocation";
import PropertySection from "components/PropertySection";
import PropertyItem from "components/PropertyItem";
import Analytics from "src/composables/Analytics";
import { useRoute, useRouter } from "vue-router";
import Utilities from "src/composables/Utilities";
import Tdsps from "src/composables/Tdsps";

const { duns_match } = ServiceLocation();

export default {
  name: "YourInfoCard",
  components: { PropertyItem, PropertySection },
  props: {
    first_name: String,
    last_name: String,
    phone_number: String,
    email: String,
    spanish: Boolean,
    action: String,
    selected_start_date: String,
    service_location_address: String,
    service_location_id: String,
    show_edit: {
      type: Boolean,
      default: true
    }
  },
  setup(props) {
    const expanded = ref(true);
    const { log_event } = Analytics();
    const router = useRouter();
    const change_info = (path) => {
      log_event({ name: 'co_customer_info_change' })
      router.push(path);
    }
    const route = useRoute();
    const { get_start_date_string, format_date } = Utilities();

    const current_path = computed(() => route.path)

    const is_service_location = computed(() => current_path.value.endsWith('service_location'));
    const is_start_date = computed(() => current_path.value.endsWith('start_date'));
    const is_customer_info = computed(() => current_path.value.endsWith('customer_information'));

    const start_date_string = computed(() => {
      return get_start_date_string(props.action, props.selected_start_date);
    })

    const has_customer_info = computed(() => {
      return props.first_name || props.last_name || props.phone_number || props.email;
    })

    const has_start_date = computed(() => {
      return props.action && (props.action === 'ASAP' || props.selected_start_date);
    })

    const should_hide = computed(() => {
      return is_service_location.value && !has_start_date.value && !has_customer_info.value;
    })

    const formatted_phone = computed(() => {
      const len = props.phone_number.length;
      if (len === 10) {
        const area_code = props.phone_number.substring(0, 3);
        const prefix = props.phone_number.substring(3, 6);
        const suffix = props.phone_number.substring(6, 10);
        return `${ area_code }-${ prefix }-${ suffix }`
      }
      return props.phone_number;
    })

    return {
      expanded,
      change_info,
      duns_match,
      current_path,
      should_hide,
      start_date_string,
      is_service_location,
      is_start_date,
      has_start_date,
      is_customer_info,
      has_customer_info,
      formatted_phone
    }
  }
}
</script>

<style scoped>

</style>
